export const disponibilitesColumnsValues: {
  dayName: string;
  week: number;
  firstLabel: string;
  firstValue: string;
  secondLabel: string;
  secondValue: string;
  thirdLabel: string;
  thirdValue: string;
  fourthLabel: string;
  fourthValue: string;
}[] = [
    {
      dayName: "Montag",
      week: 1,
      firstLabel: "1 Juni",
      firstValue: "2026-06-01",
      secondLabel: "8 Juni",
      secondValue: "2026-06-08",
      thirdLabel: "15 Juni",
      thirdValue: "2026-06-15",
      fourthLabel: "22 Juni",
      fourthValue: "2026-06-22",
    },
    {
      dayName: "Dienstag",
      week: 1,
      firstLabel: "2 Juni",
      firstValue: "2026-06-02",
      secondLabel: "9 Juni",
      secondValue: "2026-06-09",
      thirdLabel: "16 Juni",
      thirdValue: "2026-06-16",
      fourthLabel: "23 Juni",
      fourthValue: "2026-06-23",
    },
    {
      dayName: "Mittwoch",
      week: 1,
      firstLabel: "3 Juni",
      firstValue: "2026-06-03",
      secondLabel: "10 Juni",
      secondValue: "2026-06-10",
      thirdLabel: "17 Juni",
      thirdValue: "2026-06-17",
      fourthLabel: "24 Juni",
      fourthValue: "2026-06-24",
    },
    {
      dayName: "Donnerstag",
      week: 1,
      firstLabel: "4 Juni",
      firstValue: "2026-06-04",
      secondLabel: "11 Juni",
      secondValue: "2026-06-11",
      thirdLabel: "18 Juni",
      thirdValue: "2026-06-18",
      fourthLabel: "25 Juni",
      fourthValue: "2026-06-25",
    },
    {
      dayName: "Freitag",
      week: 1,
      firstLabel: "5 Juni",
      firstValue: "2026-06-05",
      secondLabel: "12 Juni",
      secondValue: "2026-06-12",
      thirdLabel: "19 Juni",
      thirdValue: "2026-06-19",
      fourthLabel: "26 Juni",
      fourthValue: "2026-06-26",
    },
    {
      dayName: "Montag",
      week: 2,
      firstLabel: "8 Juni",
      firstValue: "2026-06-08",
      secondLabel: "15 Juni",
      secondValue: "2026-06-15",
      thirdLabel: "22 Juni",
      thirdValue: "2026-06-22",
      fourthLabel: "29 Juni",
      fourthValue: "2026-06-29",
    },
    {
      dayName: "Dienstag",
      week: 2,
      firstLabel: "9 Juni",
      firstValue: "2026-06-09",
      secondLabel: "16 Juni",
      secondValue: "2026-06-16",
      thirdLabel: "23 Juni",
      thirdValue: "2026-06-23",
      fourthLabel: "30 Juni",
      fourthValue: "2026-06-30",
    },
    {
      dayName: "Mittwoch",
      week: 2,
      firstLabel: "10 Juni",
      firstValue: "2026-06-10",
      secondLabel: "17 Juni",
      secondValue: "2026-06-17",
      thirdLabel: "24 Juni",
      thirdValue: "2026-06-24",
      fourthLabel: "1 Juli",
      fourthValue: "2026-07-01",
    },
    {
      dayName: "Donnerstag",
      week: 2,
      firstLabel: "11 Juni",
      firstValue: "2026-06-11",
      secondLabel: "18 Juni",
      secondValue: "2026-06-18",
      thirdLabel: "25 Juni",
      thirdValue: "2026-06-25",
      fourthLabel: "2 Juli",
      fourthValue: "2026-07-02",
    },
    {
      dayName: "Freitag",
      week: 2,
      firstLabel: "12 Juni",
      firstValue: "2026-06-12",
      secondLabel: "19 Juni",
      secondValue: "2026-06-19",
      thirdLabel: "26 Juni",
      thirdValue: "2026-06-26",
      fourthLabel: "3 Juli",
      fourthValue: "2026-07-03",
    },
  ];
